// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { readerId, type ReaderId } from './Reader';
import { userId, type UserId } from './User';
import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.reader_access */
export type ReaderAccessId = string & { __brand: 'public.reader_access' };

/** Represents the table public.reader_access */
export default interface ReaderAccessTable {
  id: ColumnType<ReaderAccessId, ReaderAccessId | undefined, ReaderAccessId>;

  reader_id: ColumnType<ReaderId, ReaderId, ReaderId>;

  user_id: ColumnType<UserId, UserId, UserId>;

  scope: ColumnType<string, string, string>;

  _created_at: ColumnType<string, string | undefined, string>;
}

export type ReaderAccess = Selectable<ReaderAccessTable>;

export type NewReaderAccess = Insertable<ReaderAccessTable>;

export type ReaderAccessUpdate = Updateable<ReaderAccessTable>;

export const readerAccessId = z.string() as unknown as z.Schema<ReaderAccessId>;

export const readerAccess = z.object({
  id: readerAccessId,
  reader_id: readerId,
  user_id: userId,
  scope: z.string(),
  _created_at: z.string(),
}) as unknown as z.Schema<ReaderAccess>;

export const readerAccessInitializer = z.object({
  id: readerAccessId.optional(),
  reader_id: readerId,
  user_id: userId,
  scope: z.string(),
}) as unknown as z.Schema<ReaderAccessInitializer>;

export const readerAccessMutator = z.object({
  id: readerAccessId.optional(),
  reader_id: readerId.optional(),
  user_id: userId.optional(),
  scope: z.string().optional(),
}) as unknown as z.Schema<ReaderAccessMutator>;
